// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.css
// module id = 1563
// module chunks = 0